// src/main.js

import "babel-polyfill";
import Vue from "vue";
import "./interceptor";
import "./filter";
import "./mixin";
import "./global_components";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import VueClipboard from "vue-clipboard2";
import "./registerServiceWorker";

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);

// import plugin
import "./plugins";
import { GA, MAMOTO, MAMOTO_SITE_ID } from "@/const";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);

import VueAnalytics from "vue-analytics";
import VueMatomo from "vue-matomo";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
if (GA) {
  Vue.use(VueAnalytics, {
    id: GA,
    router
  });
}

// Analytics

if (MAMOTO) {
  Vue.use(VueMatomo, {
    host: MAMOTO,
    siteId: MAMOTO_SITE_ID,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    debug: false
  });
}

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
